import React from 'react';

import { Button } from '@alfalab/core-components/button';
import { SuperEllipse } from '@alfalab/core-components/icon-view/super-ellipse';
import { Link } from '@alfalab/core-components/link';
import { Modal } from '@alfalab/core-components/modal/';
import { PureCell } from '@alfalab/core-components/pure-cell';
import { MailMIcon } from '@alfalab/icons-glyph/MailMIcon';
import { PhoneMIcon } from '@alfalab/icons-glyph/PhoneMIcon';

export const HelpDeskModal = () => {
    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    return (
        <React.Fragment>
            <Button view='link' onClick={handleOpen} size='xxs'>
                Связаться с HelpDesk
            </Button>

            <Modal open={open} onClose={handleClose}>
                <Modal.Header sticky={true} hasCloser={true} title='Help Desk' />
                <Modal.Content flex={true}>
                    <PureCell direction='horizontal' verticalPadding='default'>
                        <PureCell.Graphics>
                            <SuperEllipse size={48}>
                                <PhoneMIcon />
                            </SuperEllipse>
                        </PureCell.Graphics>
                        <PureCell.Content>
                            <PureCell.Main>
                                <PureCell.Text
                                    titleColor='primary'
                                    valueColor='secondary'
                                    view='component'
                                >
                                    <Link href='tel:+74956209221' underline={false}>
                                        +7 495 620 92 21
                                    </Link>
                                </PureCell.Text>
                                <PureCell.Text
                                    titleColor='secondary'
                                    valueColor='secondary'
                                    view='primary-small'
                                >
                                    Для звонка из Москвы
                                </PureCell.Text>
                            </PureCell.Main>
                        </PureCell.Content>
                    </PureCell>

                    <PureCell direction='horizontal' verticalPadding='default'>
                        <PureCell.Graphics>
                            <SuperEllipse size={48}>
                                <PhoneMIcon />
                            </SuperEllipse>
                        </PureCell.Graphics>
                        <PureCell.Content>
                            <PureCell.Main>
                                <PureCell.Text
                                    titleColor='primary'
                                    valueColor='secondary'
                                    view='component'
                                >
                                    <Link href='tel:88003031111' underline={false}>
                                        8 800 303 11 11
                                    </Link>
                                </PureCell.Text>
                                <PureCell.Text
                                    titleColor='secondary'
                                    valueColor='secondary'
                                    view='primary-small'
                                >
                                    Для других регионов
                                </PureCell.Text>
                            </PureCell.Main>
                        </PureCell.Content>
                    </PureCell>

                    <PureCell direction='horizontal' verticalPadding='default'>
                        <PureCell.Graphics>
                            <SuperEllipse size={48}>
                                <MailMIcon />
                            </SuperEllipse>
                        </PureCell.Graphics>
                        <PureCell.Content>
                            <PureCell.Main>
                                <PureCell.Text
                                    titleColor='primary'
                                    valueColor='secondary'
                                    view='component'
                                >
                                    <Link href='mailto:helpdesk@alfabank.ru' underline={false}>
                                        helpdesk@alfabank.ru
                                    </Link>
                                </PureCell.Text>
                                <PureCell.Text
                                    titleColor='secondary'
                                    valueColor='secondary'
                                    view='primary-small'
                                >
                                    Для обращений с рабочей почты
                                </PureCell.Text>
                            </PureCell.Main>
                        </PureCell.Content>
                    </PureCell>
                </Modal.Content>
            </Modal>
        </React.Fragment>
    );
};
